import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartHands = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3334 18.6667C27.3201 16.72 29.3334 14.3867 29.3334 11.3333C29.3334 9.38841 28.5608 7.52315 27.1855 6.14788C25.8103 4.77262 23.945 4 22.0001 4C19.6534 4 18.0001 4.66667 16.0001 6.66667C14.0001 4.66667 12.3467 4 10.0001 4C8.05516 4 6.1899 4.77262 4.81463 6.14788C3.43937 7.52315 2.66675 9.38841 2.66675 11.3333C2.66675 14.4 4.66675 16.7333 6.66675 18.6667L16.0001 28L25.3334 18.6667Z",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0001 6.66699L12.0534 10.6137C11.7825 10.8826 11.5675 11.2025 11.4207 11.5549C11.274 11.9073 11.1985 12.2853 11.1985 12.667C11.1985 13.0487 11.274 13.4267 11.4207 13.7791C11.5675 14.1315 11.7825 14.4514 12.0534 14.7203C13.1467 15.8137 14.8934 15.8537 16.0534 14.8137L18.8134 12.2803C19.5052 11.6526 20.4059 11.3048 21.3401 11.3048C22.2742 11.3048 23.1749 11.6526 23.8667 12.2803L27.8134 15.827",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9999 19.9997L21.3333 17.333",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9999 23.9997L17.3333 21.333",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgHeartHands);
export default ForwardRef;
